module.exports = __webpack_public_path__ + "img/hb.d17f6e99.svg";